import { useVideoCreatorStore } from '@src/stores-v2';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useVideoCreatorDataInitialization() {
  const [urlSearchParams] = useSearchParams();
  const videoCreator = useVideoCreatorStore();

  const searchParams = Object.fromEntries(urlSearchParams.entries());
  const { storyId: storyIdParam, showcase: showcaseParam } = searchParams;

  const album = videoCreator.organization;
  const story = videoCreator.story;

  const shouldInitializeWithNewData = () => {
    const isStoryChanged = storyIdParam && story?.id !== storyIdParam;
    const isNoAlbum = showcaseParam && !album?.id;
    const isAlbumChanged = showcaseParam && album?.slug !== showcaseParam;
    return isStoryChanged || isNoAlbum || isAlbumChanged;
  };

  useEffect(() => {
    if (shouldInitializeWithNewData()) {
      videoCreator.initializeData({
        storyId: storyIdParam,
        showcaseSlug: showcaseParam,
      });
    }
  }, [storyIdParam, showcaseParam]);
}
